import { ensureAll } from '../store/driversSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import BusSelectStateful from './BusSelectStateful';



function BusesListSelector({ bus, setBus, extraBuses, setExtraBuses, ...props }) {
    const dispatch = useDispatch();


    function deleteBus(index) {
        let newArray = [...extraBuses];
        newArray.splice(index, 1);
        setExtraBuses(newArray);
    }

    useEffect(() => {
        dispatch(ensureAll());
    }, []);



    return (
        <div className="column g8" style={{ alignItems: 'flex-end' }}>

            <BusSelectStateful style={{ width: '100%' }} value={bus} setValue={setBus}/>

            { extraBuses.map((bus, index) => (
                <div className="row center-cross g8" style={{ width: '100%' }}>
                    <BusSelectStateful style={{ width: '100%' }} value={bus} setValue={(value) => {
                        let newArray = [...extraBuses];
                        newArray[index] = value;
                        setExtraBuses(newArray);
                    }}/>

                    <div className="row center-main center-cross" onClick={() => deleteBus(index)} style={{ backgroundColor: '#f88', borderRadius: 4, padding: 4, width: 32, height: 32, cursor: 'pointer' }}>
                        <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="12px" height="12px"><path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z" stroke='#fff' strokeWidth={4}></path></svg>
                    </div>
                </div>
            ))}

            <button
                onClick={() => setExtraBuses([...extraBuses, ""])}
            >Lisa buss</button>
        </div>
    );
};

export default BusesListSelector;